<template>
  <ViewTopNav :heading="this.viewType" :subheading="this.assetType" />

  <div class="position-absolute p-content z-1">
    <div class="col-12 p-0 z-1 h-100">
      <div class="row g-0 h-100">

        <div class="col-12 col-md-6 col-lg-4 m-auto" v-for="asset in assetTypes" :key="(asset || {}).guid">
          <div class="row g-0">
            <div class="col-12 position-relative z-1">

              <!-- Videos -->
              <router-link v-if="viewType === 'videos' && collectionId" :to="{
                name: 'VideoView',
                params: {
                  guid: asset.guid,
                  collectionId: asset.videoLibraryId
                }
              }" class="v-link">
                <img :src="theme.streamCdnUrl + '/' + asset.guid + '/' + asset.thumbnailFileName + '?width=700'"
                  class="img-fluid">
                <div class="render-name">
                  {{ asset.title }}
                </div>
              </router-link>

              <!-- Renders -->
              <router-link v-if="viewType === 'renders' || viewType === 'range'" :to="{
                name: 'AssetViewDetail',
                params: {
                  assetType: this.assetType,
                  viewType: this.viewType,
                  order: asset.id
                }
              }" class="r-link">
                <img
                  :src="theme.cdnUrl + '/assets/' + this.assetType + '/' + this.viewType + '/' + asset.LinkName + '?width=700'"
                  class="img-fluid">
                <div class="render-name">
                  {{ asset.title }}
                </div>
              </router-link>

              <!-- Panoramas -->
              <router-link v-if="viewType === 'panoramas' || viewType === 'virtual-tour' || viewType === 'balcony-views'"
                :to="{
                  name: 'AssetViewDetail',
                  params: {
                    assetType: this.assetType,
                    viewType: this.viewType,
                    order: asset.id
                  }
                }" class="p-link">
                <img
                  :src="theme.cdnUrl + '/assets/' + this.assetType + '/' + this.viewType + '/' + asset.LinkName + '?width=700'"
                  class="img-fluid">
                <div class="render-name">
                  {{ asset.title }}
                </div>
              </router-link>

              <!-- Floorplans -->
              <router-link v-if="viewType === 'floorplans'" :to="{
                name: 'AssetViewDetail',
                params: {
                  assetType: this.assetType,
                  viewType: this.viewType,
                  order: asset.id
                }
              }" class="f-link">
                <img
                  :src="theme.cdnUrl + '/assets/' + this.assetType + '/' + this.viewType + '/' + asset.LinkName + '?width=700'"
                  class="img-fluid">
                <div class="render-name">
                  {{ asset.title }}
                </div>
              </router-link>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <ViewBotNav />
  <OffCanvas />
</template>

<script>
import ViewTopNav from '@/components/ViewTopNav.vue';
import ViewBotNav from '@/components/ViewBotNav.vue';
import OffCanvas from "@/components/OffCanvas.vue";
import global from '../global';
import BunnyNetService from "@/services/BunnyNetService.js";
import { unslugify } from "unslugify";

export default {
  name: "AssetView",
  props: [
    'assetType',
    'viewType',
    'lid',
    'collectionId'
  ],
  components: {
    ViewTopNav,
    ViewBotNav,
    OffCanvas
  },
  data() {
    return {
      assetTypes: null,
      assetOrder: null,
      folderStructure: encodeURIComponent(this.theme.devFolder + '/assets/' + this.assetType + '/' + this.viewType + '/'),
      videoStatus: false,
      assetNames: null,
      assetUrls: null
    }
  },
  created() {
    if (this.assetType === 'three-bed-villas') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.threeBedVillasAsset.videos
        this.assetNames = this.theme.threeBedVillasAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.threeBedVillasAsset.floorplans
        this.assetNames = this.theme.threeBedVillasAsset.floorplansName
        this.assetUrls = this.theme.threeBedVillasAsset.floorplansUrl
      } else if (this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.threeBedVillasAsset.panoramas
        this.assetNames = this.theme.threeBedVillasAsset.panoramasName
        this.assetUrls = this.theme.threeBedVillasAsset.panoramasUrl
      } 
    } else if (this.assetType === 'four-bed-villas-type-B') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.fourBedVillasTypeBAsset.videos
        this.assetNames = this.theme.fourBedVillasTypeBAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.fourBedVillasTypeBAsset.floorplans
        this.assetNames = this.theme.fourBedVillasTypeBAsset.floorplansName
        this.assetUrls = this.theme.fourBedVillasTypeBAsset.floorplansUrl
      } else if (this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.fourBedVillasTypeBAsset.panoramas
        this.assetNames = this.theme.fourBedVillasTypeBAsset.panoramasName
        this.assetUrls = this.theme.fourBedVillasTypeBAsset.panoramasUrl
      }  else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.fourBedVillasTypeBAsset.renders
        this.assetNames = this.theme.fourBedVillasTypeBAsset.rendersName
        this.assetUrls = this.theme.fourBedVillasTypeBAsset.rendersUrl
      }
    } else if (this.assetType === 'recreation-centre') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.recreationCentreAsset.videos
        this.assetNames = this.theme.recreationCentreAsset.videosName
      } else if (this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.recreationCentreAsset.panoramas
        this.assetNames = this.theme.recreationCentreAsset.panoramasName
        this.assetUrls = this.theme.recreationCentreAsset.panoramasUrl
      }
    } else if (this.assetType === 'four-bed-villas-Type-A') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.fourBedVillasTypeAAsset.videos
        this.assetNames = this.theme.fourBedVillasTypeAAsset.videosName
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        
        this.assetOrder = this.theme.fourBedVillasTypeAAsset.panoramas
        this.assetNames = this.theme.fourBedVillasTypeAAsset.panoramasName
        this.assetUrls = this.theme.fourBedVillasTypeAAsset.panoramasUrl
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.fourBedVillasTypeAAsset.floorplans
        this.assetNames = this.theme.fourBedVillasTypeAAsset.floorplansName
        this.assetUrls = this.theme.fourBedVillasTypeAAsset.floorplansUrl
      } 
    } else if (this.assetType === 'exterior') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.exteriorAsset.videos
        this.assetNames = this.theme.exteriorAsset.videosName
      }
    }
    
    // Video type
    if (this.viewType === 'videos') {
      BunnyNetService.getVideos(this.lid, this.collectionId)
        .then(response => {
          // Remap array (inject asset names)
          let j = 0;
          const menuItems = response.data.items.map((item) => {
            return {
              guid: item.guid,
              videoLibraryId: item.videoLibraryId,
              thumbnailFileName: item.thumbnailFileName,
              ObjectName: item.ObjectName,
              title: this.assetNames[j],
              id: j++
            };
          });

          // Custom order array
          this.assetTypes = menuItems;

          this.videoStatus = true
        })
        .catch(error => {
          console.log(error)
        })
      // Renders, Panoramas, Floorplans type
    } else {
      BunnyNetService.getRenders(this.folderStructure, this.assetType)
        .then(response => {
          let j = 0;
          // Remap array
          const menuItems = response.data.map((item) => {
            return {
              Guid: item.Guid,
              ObjectName: unslugify(item.ObjectName),
              LinkName: item.ObjectName,
              Path: item.Path,
              IsDirectory: item.IsDirectory,
              StorageZoneName: item.StorageZoneName,
              title: this.assetNames[j],
              url: this.assetUrls[j],
              id: j++
            };
          });
          this.assetTypes = menuItems
        })
    }
  },
  methods: {
    reorder: function (data_array, real_order) {
      var i, d = {}, result = [];
      for (i = 0; i < data_array.length; ++i) {
        d[data_array[i].id] = data_array[i];
      }

      for (i = 0; i < real_order.length; ++i) {
        result.push(d[real_order[i]]);
      }

      return result;
    }
  },
  setup() {
    const { theme } = global

    return {
      theme
    }
  }
}
</script>
